import { UISettings } from 'src/app/models/ui-settings';

export class UpdateUISettingAction<K extends keyof UISettings> {
  static readonly type = '[UISettings] Toggle Setting';

  constructor(
    public setting: K,
    public value: Partial<UISettings[K]>
  ) {}
}
